import Cookies from 'js-cookie'

const LOCAL_AUTH_KEYS = [
  'profile',
  'token',
  'refresh_token',
  'id_token',
  'keycloak_sid',
  'keycloak_sub'
]

const SESSION_AUTH_KEYS = [
  'ops_keycloak_state',
  'ops_keycloak_verifier',
  'ops_keycloak_return_to'
]

export function clearAuthSession () {
  LOCAL_AUTH_KEYS.forEach(key => {
    window.localStorage.removeItem(key)
    Cookies.remove(key, { path: '/' })
  })

  SESSION_AUTH_KEYS.forEach(key => {
    window.sessionStorage.removeItem(key)
  })
}
